import { useState, useEffect } from 'react';
import { getRedemptions } from '../../../actions/promotion/redemption';
import CustomPagination from '../CustomPagination';
import RedemptionItem from './RedemptionItem';
import { useParams } from 'react-router-dom';
import DynamicFilter from '../DynamicFilter';

const promotionStatusOptions = [
  { value: '', label: 'All' },
  { value: 'hold', label: 'Hold' },
  { value: 'confirmed', label: 'Confirmed' },
  { value: 'canceled', label: 'Canceled' },
  { value: 'expired', label: 'Expired' },
];

const sortByOptions = [
  {
    label: 'Default',
    value: null,
  },
  {
    label: 'Creation Date (asc)',
    value: {
      key: 'createdAt',
      order: 'asc',
    },
  },
  {
    label: 'Creation Date (desc)',
    value: {
      key: 'createdAt',
      order: 'desc',
    },
  },
];

const filterOptions = [
  {
    label: 'Status',
    filterColumn: 'status',
    options: promotionStatusOptions,
  },
  {
    label: 'Country',
    filterColumn: 'request.sys.countryCode',
    options: [],
  },
  {
    label: 'Brands',
    filterColumn: 'request.sys.brandId',
    options: [],
  },
  {
    label: 'Stores',
    filterColumn: 'request.sys.storeId',
    options: [],
  },
  {
    label: 'Date',
    type: 'dateRange',
    filterColumn: 'createdAt',
  },

  ,
];

const PromotionRedemption = ({ promotionId, member = {} }) => {
  const { campaignTypeId } = useParams();

  const [redemptions, setRedemptions] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [pageOffset, setPageOffset] = useState(0);
  const [selectedSortBy, setSelectedSortBy] = useState(null);
  const [selectedFillers, setSelectedFilters] = useState({});

  useEffect(() => {
    if (pageOffset === 0) {
      getRedemptionsFunc();
    } else {
      setPageOffset(0);
    }
  }, [selectedFillers, selectedSortBy]);

  const getRedemptionsFunc = async ({ offset = pageOffset } = {}) => {
    try {
      const inputData = {
        pageOffset: offset,
        pageSize: 6,
        promotionId: promotionId,
        filters: {
          ...selectedFillers,
          'request.sys.campaignType':
            campaignTypeId?.toUpperCase()?.replaceAll('-', '_') || null,
          ...(member?._id ? { 'user._id': member._id } : {}),
        },
        sortBy: selectedSortBy,
      };

      const { data, success } = await getRedemptions(inputData);
      if (success) {
        setRedemptions(data?.redemptions);
        setTotalPages(data?.totalPages);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const paginationHandler = (offset) => {
    getRedemptionsFunc({ offset });
  };

  return (
    <>
      <h5 className="border-bottom pb-3 mb-4">Redemptions</h5>
      <DynamicFilter
        filters={filterOptions}
        sortByOptions={sortByOptions}
        onFilterChange={(data) => {
          setSelectedFilters(data?.filters);
          setSelectedSortBy(data?.sortBy);
        }}
      />
      <div class="bg-light fs-14 p-3 fw-bold">Redemptions Details</div>
      {redemptions?.length ? (
        <div className="table-responsive d-flex gap-1 flex-column mt-3">
          {(redemptions || [])?.map((redemption, key) => (
            <RedemptionItem redemption={redemption} key={key} />
          ))}
        </div>
      ) : (
        <div
          className="d-flex flex-column align-items-center justify-content-center"
          style={{ minHeight: 350 }}
        >
          <div style={{ color: '#939393' }}>
            <i className="bx bx-file-blank  p-3 fs-60"></i>
          </div>
          <div className="text-muted fs-18">No redemptions yet</div>
        </div>
      )}
      <CustomPagination
        pageOffset={pageOffset}
        totalPages={totalPages}
        setPageOffset={setPageOffset}
        paginationHandler={paginationHandler}
      />
    </>
  );
};

export default PromotionRedemption;
